/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AdapterApiService } from "@modules/core/services";
import { InjuryData } from "@modules/core/state";
import { ConfigurationService } from "@pgr-cla/cla-configuration";
import { Observable, throwError } from "rxjs";
import { catchError, first, switchMap } from "rxjs/operators";
@Injectable()
export class InjuryService {
  constructor(
    private adapterApiService: AdapterApiService,
    private config: ConfigurationService
  ) {}

  getInjuryInfo(policyId: string): Observable<InjuryData> {
    return this.config.configuration$.pipe(
      first((config: any) => config !== null && config !== undefined),
      switchMap((config: any) => {
        return this.adapterApiService
          .get<InjuryData>(
            config.adapterApiRouteUrl,
            `/lossviewerapi/v1/injury/${policyId}`
          )
          .pipe(
            catchError((error) => {
              return this.errorMasking(error, `Party ${policyId} Not Found`);
            })
          );
      })
    );
  }

  private errorMasking(error: HttpErrorResponse, message: string) {
    if (error.status === 404) {
      return throwError(
        () => ({ ...error, statusText: message } as HttpErrorResponse)
      );
    }
    return throwError(() => error);
  }
}
